import React from 'react';
import MembershipSearchResultTemplate from '../../components_membership_hotel/template/hotel/membershipSearchResultTemplate';
import { getReserveList, getSenyuNenList, selectSaveSearchInfo } from '../../const';
import messageConst from '../../const/messageConst';
import common from '../../resources/js/common/common';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
// import { confirmHotelReservation, getFavoriteCondition } from "../const/RTCC";
// import common from "../resources/js/common/common";


class MembershipSearchResult extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 検索条件保存モーダル
            reservationPopup: false,
            popupDataList: [],
            popupData: {},
            popupMode: "",
            popupTitle: "",
            reflectFlg: false,
            // チェックイン・アウトモーダル
            calendarPopup: false,
            // チェックリストモーダル
            checkListPopup: false,
            // 詳細ポップアップ情報
            popupTitle: "",
            popupMode: "",
            beforeAreaId: "",
            beforeCountryId: "",
            changeFlg: false,
            // エラー解除フラグ
            clickCount: 0,
            // 1室の大人こども人数リスト
            adultNumList: [],
            chlidNumList: [],
            // 予約確認モーダル
            membershipReservationConfPopup: false,
            reservationConfList: [],
            // 予約キャンセルモーダル
            membershipReservationCancelPopup: false,
            // 占有日モーダル
            selectKeiyakuNo: "",
            senyuubiPopup: false,
            shokaKenriNenList: [],
            openFacilityFlg: true,
            // 「ホームFLとは」モーダル
            descHomeFlPopup: false,
            // ログインタイプ
            loginType: "",
            // ローディング画面表示フラグ
            loadingFlg: false
        };
    };

    render() {

        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            },
        }

        // モーダルを閉じる
        const onClickClosePopupWindow = () => { this.setState({ membershipPopup: false, reservationPopup: false }); };

        // 1室あたりの年齢層リスト作成
        const createAgeCountList = (count) => {
            let adults = [];
            for (let i = 1; i <= count; i++) {
                adults.push({ id: i, value: i + "人" });
            }
            let children = [];
            for (let i = 0; i < count; i++) {
                children.push({ id: i, value: i + "人" });
            }
            this.setState({
                adultNumList: adults,
                chlidNumList: children
            });
        }
        // 検索条件保存モーダル
        const onClickOpenReservationPopupWindow = (id, loginId) => {
            this.setState({
                membershipPopup: !this.state.membershipPopup,
                popupData: {},
                popupDataList: [],
                resData: {}
            });
            let title = "";
            if (id != undefined) {
                if (id == 'savedSearch') {
                    title = "保存した検索条件"
                    common.doPost(selectSaveSearchInfo, { memberCode: loginId }, afterSelectSaveSearchInfo);
                    // let dataList = [
                    //     {
                    //         label: "施設",
                    //         text: "東京ベイコート俱楽部",
                    //         type: "row"
                    //     },
                    //     {
                    //         label: "ご利用人数",
                    //         text: "大人　1人\n小人　1人",
                    //         type: "row"
                    //     },
                    //     {
                    //         label: "室数",
                    //         text: "2室",
                    //         type: "row"
                    //     },
                    //     {
                    //         label: "詳細条件",
                    //         text: "朝食あり",
                    //         type: "row"
                    //     }
                    // ]
                    // this.setState(
                    //     {
                    //         popupDataList: dataList,
                    //         resData: {}
                    //     }
                    // );
                }
                else if (id == 'bookConfirm') {
                    title = "予約確認"
                    // common.doPost(confirmHotelReservation, { loginId: loginId }, afterConfirmHotelReservation);
                }
                this.setState(
                    {
                        popupMode: id,
                        popupTitle: title
                    }
                );
            }
        }
        // 保存した検索条件取得後処理
        const afterSelectSaveSearchInfo = (res) => {
            let resData = res.data;
            let dataList = [];
            if (resData.resultCode == 0) {
                let facility = resData.shisetsuData ? resData.shisetsuData : "";
                let roomCnt = resData.numberOfRoom ? resData.numberOfRoom + "室" : "";
                let adultCnt = resData.numberOfAdult ? resData.numberOfAdult + "人" : "";
                let childCnt = resData.numberOfChild ? resData.numberOfChild + "人" : "";
                let humanNum = "";
                if (adultCnt) {
                    humanNum = "大人　" + adultCnt + (childCnt ? "\n小学生　" + childCnt : "");
                } else {
                    humanNum = childCnt ? "小学生　" + childCnt : "";
                }
                let detailCondition = resData.detailedConditionsList ? resData.detailedConditionsList : "";
                dataList = [
                    {
                        label: "ホテル",
                        text: facility,
                        type: "row"
                    },
                    {
                        label: "ご利用人数",
                        text: humanNum,
                        type: "row"
                    },
                    {
                        label: "室数",
                        text: roomCnt,
                        type: "row"
                    },
                    {
                        label: "詳細条件",
                        text: detailCondition,
                        type: "row"
                    }
                ]
                this.setState(
                    {
                        popupDataList: dataList,
                        resData: resData,
                        reservationPopup: true
                    }
                );
            } else {
                this.setState(
                    {
                        popupMode: "message",
                        popupMessage: messageConst.NOT_SAVED_SEARCH
                    }
                );
            }
        }
        // 予約情報取得後処理
        const afterConfirmHotelReservation = (res) => {
            const data = res.data;
            if (data.resultCode != 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.reserve,
                    }
                );
            }
        }
        // popupMode変更
        const setPopupMode = (mode) => this.setState({ popupMode: mode })

        // popUpMessage変更
        const setPopupMessage = (message) => this.setState({ popupMessage: message })

        // チェックインモーダル
        const onClickOpenCalendarWindow = (e) => {
            this.setState({ calendarPopup: !this.state.calendarPopup });
            let checkInFlg = false;
            let checkOutFlg = false;
            let title = "";
            if (e != undefined) {
                if (e.target.id == 'checkIn') {
                    checkInFlg = true;
                    checkOutFlg = false;
                    title = "チェックイン"
                }
                else if (e.target.id == 'checkOut') {
                    checkInFlg = false;
                    checkOutFlg = true;
                    title = "チェックアウト"
                }
                this.setState(
                    {
                        checkInFlg: checkInFlg,
                        checkOutFlg: checkOutFlg,
                        popupTitle: title
                    }
                );
            }
        }

        // チェックリストモーダル
        const onClickOpenCheckListWindow = (e) => {
            this.setState({ checkListPopup: !this.state.checkListPopup });
            let facilityFlg = false;
            let detailCriteriaFlg = false;
            let title = "";
            if (e != undefined) {
                if (e.target.id == 'facility') {
                    facilityFlg = true;
                    detailCriteriaFlg = false;
                    title = "エリア・ホテル"
                }
                else if (e.target.id == 'detailCriteria') {
                    facilityFlg = false;
                    detailCriteriaFlg = true;
                    title = "詳細条件"
                }
                this.setState(
                    {
                        facilityFlg: facilityFlg,
                        detailCriteriaFlg: detailCriteriaFlg,
                        popupTitle: title
                    });
            }
        }
        // 詳細ポップアップ表示情報設定
        const setPopupData = (title, mode, data) => {
            this.setState({
                membershipPopup: !this.state.membershipPopup,
                popupTitle: title,
                popupMode: mode,
                popupData: data
            });
        }

        const onClickCountWindow = () => {
            console.log("onClickCountWindow");
            this.setState({ clickCount: this.state.clickCount + 1 });
        }

        // 予約確認モーダル
        const onClickOpenReservationConfPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true, loadingFlg: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId }, afterGetReserveList);
        }
        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
            this.setState({ loadingFlg: false });
        }
        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false});};

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ membershipReservationCancelPopup: true });
        }
        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => { this.setState({ membershipReservationCancelPopup: false }); };

        // ログインタイプの取得
        const setLoginType = (loginType) => { this.setState({ loginType: loginType }); }

        // 選択契約番号設定
        const setSelectKeiyakuNo = (keiyakuNo) => this.setState({ selectKeiyakuNo: keiyakuNo })

        // 占有日モーダル
        const onClickOpenSenyuubiWindow = (keiyakuNo) => {
            common.doPost(getSenyuNenList, { keiyakuNo: keiyakuNo }, afterGetSenyuNenList);
        }

        // 「ホームFlとは」モーダル
        const onClickOpenDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: true }); };

        // 占有日一覧取得後処理
        const afterGetSenyuNenList = (res) => {
            const data = res.data;
            if (data.resultCode == 0) {
                this.setState({
                    senyuubiPopup: true,
                    shokaKenriNenList: data.shokaKenriNenList
                });
            } else {
                this.setState({ 
                    senyuubiPopup: true,
                    shokaKenriNenList: []
                });
            }
        }

        // 占有日モーダルを閉じる
        const onClickCloseSenyuubiPopupWindow = () => { this.setState({ senyuubiPopup: false }); };

        // 「ホームFlとは」モーダルを閉じる
        const onClickCloseDescriptionHomeFlWindow = () => { this.setState({ descHomeFlPopup: false }); };

        // 開業施設フラグ設定
        const setOpenFacilityFlg = (flg) => { this.setState({ openFacilityFlg: flg }); };

        return (
            <div style={style.base}>
                <MembershipSearchResultTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                    setPopupMode={setPopupMode}
                    setPopupData={setPopupData}
                    setPopupMessage={setPopupMessage}
                    setLoginType={setLoginType}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickCountWindow={onClickCountWindow}
                    createAgeCountList={createAgeCountList}
                    setSelectKeiyakuNo={setSelectKeiyakuNo}
                    setOpenFacilityFlg={setOpenFacilityFlg}
                    onClickOpenReservationConfPopupWindow={onClickOpenReservationConfPopupWindow}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    onClickOpenSenyuubiWindow={onClickOpenSenyuubiWindow}
                    onClickCloseSenyuubiPopupWindow={onClickCloseSenyuubiPopupWindow}
                    onClickOpenDescriptionHomeFlWindow={onClickOpenDescriptionHomeFlWindow}
                    onClickCloseDescriptionHomeFlWindow={onClickCloseDescriptionHomeFlWindow}
                />
            </div>
        )
    }
}
export default MembershipSearchResult;
